import * as React from 'react';
// @ts-ignore
import { Spring } from 'react-spring';
import styled from 'styled-components';

const Container = styled.div`
  width: 100%;
  height: 100%;
  max-height: 0;
  overflow: hidden;

  &.allow-overflow {
    overflow: visible;
  }
`;

const OuterWrapper = styled.div`
  display: flex;
`;

const InnerWrapper = styled.div`
  width: 100%;
`;

type CollapseProps = {
  open: boolean;
  collapsedHeight?: number;
  allowOverflow?: boolean;
  children: React.ReactNode;
};

class Collapse extends React.Component<CollapseProps, {}> {
  static defaultProps = {
    collapsedHeight: 0,
    open: false,
  };

  private outerWrapper: any = React.createRef<HTMLDivElement>();

  render() {
    const { children, open, allowOverflow } = this.props;
    const node = this.outerWrapper.current;
    const outerWrapperHeight = node ? node.clientHeight : 0;
    // TODO: Add easing function.
    return (
      <Spring
        config={{ tension: 200, friction: 30 }}
        from={{ maxHeight: !open ? outerWrapperHeight : 0 }}
        to={{ maxHeight: !open ? 0 : outerWrapperHeight }}
      >
        {(styleProps: any) => (
          <Container style={styleProps} className={allowOverflow ? 'allow-overflow' : ''}>
            <OuterWrapper ref={this.outerWrapper}>
              <InnerWrapper>{children}</InnerWrapper>
            </OuterWrapper>
          </Container>
        )}
      </Spring>
    );
  }
}

export default Collapse;
